<ion-header>
  <div class="left">
    <div class="back-button" (click)="onBackButtonClick()">
      <app-svg-icon [name]="'arrow-back'"></app-svg-icon>
    </div>
    <div class="title">
      {{ "@pages.termsOfUse.header" | translate }}
    </div>
  </div>
</ion-header>
<div class="padding-md wrap">
  {{ "@pages.termsOfUse.text" | translate }}
</div>
